import React from "react";
import { FormValues, getValue, InputFormGroup } from "o4a-react";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { ExaInfraUpdateTagsProps, newExaInfraUpdateTags } from "./ExaInfraUpdateTags";

export interface ExaInfraEditTagsProps
extends OperationActionProps {
  exaInfraId: string;
  /**
   * @default [] empty array
   */
  defaultTags?: { name: string; value: string; }[];
}

const ExaInfraEditTags = ({
  defaultTags = [],
  exaInfraId,
  location,
  targetId,
  onCancel,
  onExecute,
}: ExaInfraEditTagsProps): JSX.Element => {
  const { trigger: triggerExaInfraUpdateTags } = useOperation<ExaInfraUpdateTagsProps>(newExaInfraUpdateTags);

  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags}
      onSubmit={(formValues: FormValues) => {
        const tags: { name: string; value: string; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);

        triggerExaInfraUpdateTags({
          exaInfraId,
          location,
          tags,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newExaInfraEditTags = (props: ExaInfraEditTagsProps): JSX.Element => (
  <ExaInfraEditTags {...props} />
);
